import { useEffect, useState } from "react";

export const languages = {
  //
  // ENGLISH
  //
  en: {
    PleaseReview: "Please double check the code for errors: ",
    GoBack: "Go Back",
    AllGoodToSubmit: "Signature ready to submit",
    AllLocations: "All locations signed. You may submit",
    Draw: "Draw",
    Type: "Text",
    Agree: "I Agree",
    AgreeSign: "Agreeing to Sign",
    ClickingAgree:
      'By clicking "I Agree" you consent to conduct business electronically, as well as to provide your signature electronically with respect to the execution of this specific Agreement.  You understand that executing this Agreement electronically has the same legal effect as a paper agreement and a non-electronic signature.  An electronic copy of this Agreement following consent and execution will be sent to you directly to the electronic mail address which you have provided to us.  Upon reasonable request, you may receive without charge an additional electronic copy, or a paper copy of the electronically executed agreement, by contacting us at info@safehomesecurityinc.com, or 1-800-833-3211. You may also revoke this consent at any time by contacting us as described above. You will need a .pdf file reader to review an electronic copy of this agreement, as well as a printer to print should you desire a tangible copy absent requesting a paper copy from us. We will retain an electronic copy of the same. ',
    MissingSignature: "Missing Signature Location",
    MissingInitial: "Missing Initial Location",
    MissingLocation: "Missing Location",
    MaySubmit: "All locations signed! You may submit.",
    LookOver:
      "Look over the document for missing yellow buttons, then try submitting again.",
    Nice: "Nice!",
    Current: "en",
    Language: "Language",
    English: "English",
    Spanish: "Spanish",
    EnterCode24: "Enter 24-digit Access Code",
    EnterCode6: "Enter 6-digit Access Code",
    EnterEmail: "Enter Email Address",
    ViewDocument: "View Document",
    AccessCode: "Access Code",
    SafeSign: "SafeSign",
    "Please enter your access code":
      "Please enter your Access Code. Please check your email for this code and enter it in the field below.",
    Experience:
      "If you experience any problems or technical difficulties with SafeSign, please contact us at",
    Help: "Help",
    DataError:
      "Access Code must not contain any special characters (#, !, <>, @, etc.) and must be 24 characters with NO spaces. Please try again.",
    Congratulations:
      "Your portion of the electronic signing process is complete. You will receive an email notification that your document is ready to download as soon as it is processed and signed by all parties. Please check your email shortly for a link to access your electronically executed document after it is complete. ",
    DocumentSigned: "Document Signed",
    TakeMeHome: "Take Me Home",
    ContactSupport: "Contact Support",
    SorryError: "Sorry, an error has occurred, Requested page not found",
    Oops: "Oops!",
    NotFound: "404 Not Found",
    HelpQuestions:
      "Please browse these common help questions regarding your document signing process. If you are unable to obtain the answer to your question, please contact us",
    WhySign: "Why did I receive this document to sign?",
    ContractAgreement:
      "You participated in a contract agreement with us for home security products and/or service.  This is considered a contractual agreement between parties, and you are required to sign the document for it to be legally binding.",
    ContactWho: "Who do I contact if I have a question about this document?",
    HitReply:
      'You may hit "reply" and construct your email question or send an email to',
    MultipleDocuments: "Why are there multiple areas to sign on the document?",
    PartDocument:
      "Parts of this document reference the terms and conditions of the contract, e.g. “any applied warranty,” and “any applied insurance,” while other sections reference a required signature to accept those terms and conditions, and that you agree to such terms and conditions as outlined in the document.  You have three (3) sections of this document to supply your initials and/or signature before submitting the document.",
    UseCode: "I have an access code - where do I use this code?",
    GetACopy: "How do I get a copy of my signed document?",
    AfterSign:
      "After you initial/sign all required fields and hit SUBMIT, an email will be sent contains a link to a PDF file.  Click on that link to print and/or download the file to your computer.",
    EmailedCode:
      "If you were emailed an access code to access your electronic document, you may click on",
    THISLINK: "THIS LINK",
    EmailedCode2:
      "and type your code in the provided field.  Then click on the VIEW DOCUMENT button which will launch the page that contains the document for you to sign.",
    DocumentDeclined: "Document Declined",
    LeavePage:
      "The document was declined. You may leave this page whenever. SafeHome was notified of the declining.",
    InvalidCode: "Something Went Wrong",
    SorryCode:
      "Sorry, an error has occured, Please check the code and try again.",
    MouseDraw:
      "Please use your mouse to draw your signature in the box below, or type in your signature in the text tab.",
    SubmitSignature:
      'By clicking on "Submit", you agree that the digital signature you provided is the electronic representation of your personal signature for this legally binding contract.   You further understand that this digital signature acts the same as a non-electronic signature on a paper contract. ',
    SignatureRequired: "Your Signature Required",
    InitialRequired: "Your Initials Required",
    InputRequired: "Your Input Required",
    Next: "Sign",
    Submit: "Submit",
    Close: "Close",
    Clear: "Clear",
    Ok: "Ok",
    Sign: "Sign",
    Initials: "Initials",
    Input: "Input",
    Login: "View Documents",
    LoginEmail:
      "To view your contrats with SHS. Please enter your email address. You will be emailed a one time code to view all your documents.",
    ViewDocuments: "View Documents",
    DocumentsFor: "Documents for",
    Documents: "Documents",
    ReviewAndSign: "Review and Sign Documents",
    FinishedDocuments: "Review and download finished documents",
    InProgress: "In Progress",
    Completed: "Completed",
  },
  //
  // SPANISH
  //
  es: {
    PleaseReview: "Vuelva a verificar el código para ver si hay errores: ",
    GoBack: "Regresa",
    AllGoodToSubmit: "Todo bien. Puede enviar",
    AllLocations: "Todas las ubicaciones firmadas. Puede enviar",
    Draw: "Dibujar",
    Type: "Texto",
    Agree: "Estoy de acuerdo",
    AgreeSign: "Aceptar firmar",
    ClickingAgree:
      'Al hacer clic en "Acepto", usted acepta realizar negocios electrónicamente, así como proporcionar su firma electrónicamente con respecto a la ejecución de este Acuerdo específico. Usted comprende que ejecutar este Acuerdo electrónicamente tiene el mismo efecto legal que un acuerdo en papel y una firma no electrónica. Se le enviará una copia electrónica de este Acuerdo después del consentimiento y la ejecución directamente a la dirección de correo electrónico que nos haya proporcionado. Previa solicitud razonable, puede recibir sin cargo una copia electrónica adicional, o una copia en papel del acuerdo ejecutado electrónicamente, comunicándose con nosotros a info@safehomesecurityinc.com, o al 1-800-833-3211. También puede revocar este consentimiento en cualquier momento comunicándose con nosotros como se describe anteriormente. Necesitará un lector de archivos .pdf para revisar una copia electrónica de este acuerdo, así como una impresora para imprimir si desea una copia tangible en ausencia de solicitarnos una copia en papel. Conservaremos una copia electrónica de la misma.',
    MissingSignature: "Falta la ubicación de la firma",
    MissingInitial: "Falta la ubicación inicial",
    MissingLocation: "Ubicación faltante",
    MaySubmit: "¡Todas las ubicaciones firmadas! Puede enviar.",
    LookOver:
      "Revise el documento en busca de ubicaciones firmadas faltantes, luego intente enviarlo nuevamente.",
    Nice: "¡Bueno!",
    Current: "es",
    Language: "Idioma",
    English: "Inglés",
    Spanish: "Español",
    EnterCode24: "Ingrese su código de acceso de 24 dígitos",
    EnterCode6: "Ingrese su código de acceso de 6 dígitos",
    EnterEmail: "Ingrese su dirección de correo electrónico",
    ViewDocument: "Ver documento",
    SafeSign: "SafeSign",
    AccessCode: "Código de acceso",
    "Please enter your access code":
      "Por favor ingrese su Código de Acceso. Verifique su correo electrónico para obtener este código e ingréselo en el campo a continuación.",
    Experience:
      "Si tiene algún problema o dificultad técnica con su código de acceso, contáctenos en",
    Help: "Ayuda",
    DataError:
      "Access Code must not contain any special characters (#, !, <>, @, etc.) and must be 24 characters with NO spaces. Please try again.",
    Congratulations:
      "Su parte del proceso de firma electrónica está completa. Recibirá una notificación por correo electrónico de que su documento está listo para descargar tan pronto como sea procesado y firmado por todas las partes. Verifique su correo electrónico en breve para obtener un enlace para acceder a su documento ejecutado electrónicamente una vez que esté completo.",
    DocumentSigned: "Documento firmado",
    TakeMeHome: "Llévame a casa",
    ContactSupport: "Soporte de contacto",
    SorryError:
      "Lo sentimos, ha ocurrido un error, no se encontró la página solicitada",
    Oops: "¡UPS!",
    NotFound: "404 No Encontrado",
    HelpQuestions:
      "Explore estas preguntas de ayuda comunes con respecto a su documento proceso de firma. Si no puede obtener la respuesta a su pregunta, por favor contáctenos",
    WhySign: "¿Por qué recibí este documento para firmar?",
    ContractAgreement:
      "Usted participó en un acuerdo de contrato con nosotras para productos y/o servicios de seguridad para el hogar. Debido a que esto se considera un acuerdo contractual entre partes, debe firmar el documento para que sea legalmente vinculante.",
    ContactWho:
      "¿Con quién me comunico si tengo una pregunta sobre este documento?",
    HitReply:
      'Puede hacer clic en "responder" y crear su pregunta por correo electrónico o enviar una Email para',
    MultipleDocuments:
      "¿Por qué hay múltiples áreas para firmar en el documento?",
    PartDocument: `Partes de este documento hacen referencia a los términos y condiciones del contrato, p. "cualquier garantía aplicada" y "cualquier seguro aplicado", mientras que otras secciones hacen referencia a una firma requerida para aceptar esos términos y condiciones, y que usted acepta dichos términos y condiciones como se describen en el documento. Tiene tres (3) secciones de este documento para proporcionar sus iniciales y/o firma antes de enviar el documento.`,
    GetACopy: "¿Cómo obtengo una copia de mi documento firmado?",
    AfterSign:
      "Después de poner sus iniciales/firmar todos los campos obligatorios y presionar ENVIAR, se enviará un correo electrónico que contiene un enlace a un archivo PDF. Haga clic en ese enlace para imprimir y/o descargar el archivo a su computadora.",
    EmailedCode:
      "Si le enviaron por correo electrónico un código de acceso para acceder a su documento electrónico, puede hacer clic en ",
    THISLINK: "ESTE ENLACE",
    EmailedCode2:
      "y escribir su código en el campo proporcionado. Luego haga clic en el botón VER DOCUMENTO que abrirá la página que contiene el documento para que lo firme.",
    Close: "Cerrar",
    DocumentDeclined: "Documento Rechazado",
    LeavePage:
      "El documento fue rechazado. Puede abandonar esta página cuando lo desee. SafeHome fue notificado de la disminución.",
    InvalidCode: "Algo salió mal",
    SorryCode:
      "Lo sentimos, se ha producido un error. Por favor, compruebe el código y vuelva a intentarlo.",
    MouseDraw:
      "Use su mouse para dibujar su firma en el cuadro a continuación, o escriba su firma en la pestaña de texto.",
    SubmitSignature:
      'Al hacer clic en "Enviar", usted acepta que la firma digital que proporcionó es la representación electrónica de su firma para este contrato legalmente vinculante y actúa de la misma manera que una firma de lápiz y papel.',
    SignatureRequired: "Su firma requerida",
    InitialRequired: "Sus iniciales requeridas",
    InputRequired: "Usted ingresa Obligatorio",
    Next: "Señal",
    Submit: "Enviar",
    Clear: "Claro",
    Ok: "De acuerdo",
    Sign: "Señal",
    Initials: "Iniciales",
    Input: "Aporte",
    Login: "Acceso",
    LoginEmail:
      "Please enter your email address. You will be emailed shortly with the login code to view all your documents.",
    ViewDocuments: "View Documents",
    DocumentsFor: "Documentos para",
    Documents: "Documentos",
    ReviewAndSign: "Revisar y firmar documentos",
    FinishedDocuments: "Revisar y descargar documentos terminados",
    InProgress: "En progreso",
    Completed: "Terminado",
  },
};

export const useLanguage = (sid) => {
  let [lang, setLang] = useState(languages["en"]);

  useEffect(() => {
    let _lang = navigator.language.toLowerCase();
    if (!(_lang in languages)) {
      _lang = "en";
    }
    lang = languages[_lang];
    setLang(languages[_lang]);
  }, []);

  return [lang, setLang];
};
